import { JsonItem } from "../list-management.objects";
import { SpecialCaseEntity } from "../list-management.form-sections";
import { DocumentInfoV2 } from "../../../../shared/components/document-tree/document-tree.objects";
import _ from "lodash";
export class FileUpload implements SpecialCaseEntity {
    id: string;
    displayName: string;
    description: string;
    propertyName: string;
    isRequired: boolean;
    allowMultipleUploads: boolean;
    isEdit: boolean;

    addAttachmentsRoute: string; 
    getAttachmentsRoute: string;
    removeAttachmentsRoute: string;

    rootFolderPath: string;
    propertyIdName: string;

    currentItems: any[];
    currentDocuments: DocumentInfoV2[];
    filesToUpload: File[];
    filesToDelete: DocumentInfoV2[];

    constructor(id: string, propertyName: string, displayName: string, description: string, isRequired: boolean, rootFolderPath: string, isEdit: boolean = false, allowMultipleUploads: boolean = false) {
        this.id = id;
        this.displayName = displayName;
        this.description = description;
        this.propertyName = propertyName;
        this.isRequired = isRequired;
        this.allowMultipleUploads = allowMultipleUploads;
        this.isEdit = isEdit;

        this.propertyIdName = "Id";
        this.getAttachmentsRoute = "/api/upload-service/get-uploads";
        this.addAttachmentsRoute = "/api/upload-service/add-uploads";
        this.removeAttachmentsRoute = "/api/upload-service/remove-uploads";

        this.rootFolderPath = rootFolderPath;

        this.filesToUpload = [];
        this.filesToDelete = [];
        this.currentItems = [];
    }

    generateHtml(): string {
        let size = "col-lg-5";
        let required = "";
        if (this.isRequired) required = "required";

        let multiple = "";
        let displayFile = "File";
        if (this.allowMultipleUploads) {
            multiple = "multiple";
            displayFile = "Files";
        }

        let html = "";

        // HTML for new 
        if (!this.isEdit) {
            html = `
                <div class="mb-2">
                    <label class="${required}">${this.displayName}</label>
                    ${this.description != "" ? `<p class='form-text mb-1 mt-0'>${this.description}</p>` : ``}
                </div>
                <div id="${this.id}-container" class="${size} mb-3 px-0">
                    <div id="${this.id}-file-upload-block" class="file-upload-block p-3">
                        <div class="text-center">
                            <i class="fas fa-cloud-upload-alt fa-2x"></i>
                        </div>
                        <p class="text-center">Drag and Drop ${displayFile} Here!</p>

                        <input id="${this.id}" class="position-absolute file-upload-input invisible" type="file" ${multiple}/>

                        <div class="text-center mb-3">
                            <label class="btn btn-small revampp-white-btn choose-file-btn" for="${this.id}">Choose ${displayFile} <i class="fa-solid fa-file pl-1"></i></label>
                        </div>

                        <div class="file-upload-gallery attachment-collapse-table">
                                
                        </div>
                    </div>
                </div>
                <div id="${this.id}-error-text" class="d-none">
                    <p class="danger-text">Please upload a file.</p>
                </div>
            `
        }
        else {
            html = `
                <div class="mb-2">
                    <label class="${required}">${this.displayName}</label>
                    ${this.description != "" ? `<p class='form-text mb-1 mt-0'>${this.description}</p>` : ``}
                </div>
                <div class="row d-none" id="${this.id}-row">
                    <div class="col-md-6 col-12">
                        <div id="${this.id}-container" class="mb-3 px-0">
                            <div id="${this.id}-file-upload-block" class="file-upload-block p-3">
                                <div class="text-center">
                                    <i class="fas fa-cloud-upload-alt fa-2x"></i>
                                </div>
                                <p class="text-center">Drag and Drop ${displayFile} Here!</p>

                                <input id="${this.id}" class="position-absolute file-upload-input invisible" type="file" ${multiple}/>

                                <div class="text-center mb-3">
                                    <label class="btn btn-small revampp-white-btn choose-file-btn" for="${this.id}">Choose ${displayFile} <i class="fa-solid fa-file pl-1"></i></label>
                                </div>

                                <div class="file-upload-gallery attachment-collapse-table">
                                
                                </div>
                            </div>
                        </div>
                        <div id="${this.id}-error-text" class="d-none">
                            <p class="danger-text">Please upload a file.</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="edit-attachments-label font-weight-500 mb-2">Added ${this.propertyName}: <span id="${this.id}-added-attachments-count"></span></div>
                        <div class="attachment-collapse-table added-attachments-table" id="${this.id}-added-attachments-table">

                        </div>
                    </div>
                </div>
                <div id="${this.id}-loading-container" class="py-5">
                    <div class="text-center pb-2 font-size16 font-weight-500">Loading</div>
                    <div class="text-center">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            `
        }
        
        return html;
    }

    initialize(pickLists: JsonItem[], entityArr: any[]): void {
        this.filesToUpload = [];
        this.filesToDelete = [];
        this.currentItems = entityArr;

        this.currentDocuments = [];

        if (this.isEdit) {
            this.showLoading(true);
            this.getDocuments().then(result => {
                if (result["items"]) {
                    this.currentDocuments = JSON.parse(result["items"]);
                }
                this.updateAddedAttachments();
                this.showLoading(false);
                this.initializeAttachments();
            });
        }
        else {
            this.initializeAttachments();
        }

        
    } 

    initializeAttachments(): void {
        // disable default behavior for upload blocks
        let uploadBlock = $(`#${this.id}-file-upload-block`)

        uploadBlock.on("dragenter dragover dragleave drop", (e) => {
            e.preventDefault();
            e.stopPropagation();
        });

        // disable default behavior for modal
        $(`#${this.id}-container`).on("dragenter dragover dragleave drop", (e) => {
            e.preventDefault();
            e.stopPropagation();
        });

        uploadBlock.on("dragenter dragover", (e) => {
            uploadBlock.addClass("highlight-upload-block");
        })

        uploadBlock.on("dragleave drop", (e) => {
            uploadBlock.removeClass("highlight-upload-block");
        })

        uploadBlock.on("drop", (e) => {
            if (!this.allowMultipleUploads) {
                this.filesToUpload = [];

                if (this.isEdit) {
                    this.currentDocuments.forEach(doc => this.filesToDelete.push(doc));
                    this.currentDocuments = [];
                    this.updateAddedAttachments();
                }
            }

            let uploadedFiles = e.originalEvent.dataTransfer.files;

            if (uploadedFiles.length <= 0) {
                return;
            }

           
            if (this.allowMultipleUploads) {
                for (let i = 0; i < uploadedFiles.length; i++) {
                    this.filesToUpload.push(uploadedFiles[i])
                }
            }
            else {
                for (let i = 0; i < 1; i++) {
                    this.filesToUpload.push(uploadedFiles[i])
                }
            }

            this.drawGallery();
        })

        let uploadInput = $(`#${this.id}`);
        uploadInput.on("change", (e) => {
            if (!this.allowMultipleUploads) {
                this.filesToUpload = [];

                if (this.isEdit) {
                    this.currentDocuments.forEach(doc => this.filesToDelete.push(doc));
                    this.currentDocuments = [];
                    this.updateAddedAttachments();
                }
            }

            let uploadedFiles: File[] = uploadInput.prop("files");

            if (uploadedFiles.length <= 0) {
                return;
            }

            for (let i = 0; i < uploadedFiles.length; i++) {
                this.filesToUpload.push(uploadedFiles[i])
            }

            this.drawGallery();
        });

        this.initializeCurrentDocTable();
    }

    initializeCurrentDocTable(): void {
        $(`#${this.id}-row`).find(".delete-attachment-btn").on("click", async (e) => {
            let button = $(e.currentTarget);
            let fileIndex: string = button.data("id");
            let parsedIndex = parseInt(fileIndex);
            if (parsedIndex >= 0) {
                let foundFile = this.currentDocuments[parsedIndex];
                if (foundFile) {
                    this.filesToDelete.push(foundFile);
                    this.currentDocuments.splice(parsedIndex, 1);
                    this.updateAddedAttachments();
                }
            }
        })
    }

    showLoading(isLoading: boolean) {
        if (isLoading) {
            $(`#${this.id}-row`).addClass("d-none");
            $(`#${this.id}-loading-container`).removeClass("d-none");
        }
        else {
            $(`#${this.id}-row`).removeClass("d-none");
            $(`#${this.id}-loading-container`).addClass("d-none");
        }
    }

    async getDocuments() {
        let result: any;

        if (this.currentItems.length != 1) return;
        let currentId = _.get(this.currentItems[0], this.propertyIdName);

        let requestBody = {
            rootFolder: this.rootFolderPath,
            propertyName: this.propertyName,
            id: currentId
        }

        try {
            result = await $.ajax(this.getAttachmentsRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: JSON.stringify(requestBody),
                contentType: "application/json; charset=utf-8"
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    createDocumentTable(): string {
        // Create List of currently stored documents
        let addedAttachmentsContent = "";

        if (this.currentDocuments.length == 0 && this.filesToDelete.length == 0) {
            return `<div class="font-weight-500">No Current ${this.propertyName}</div>`
        }

        // Show deleted documents
        for (let i = 0; i < this.filesToDelete.length; i++) {
            let document = this.filesToDelete[i];
            let documentContent = `
                <div class="card">
                    <div class="card-header deleted-card" id="added-attachment-${i}">
                        <div class="row justify-content-between">
                            <div class="col">
                                <div class="header-text">
                                    <a class="text-decoration-none d-flex align-items-center">
                                        <span class="expand-text d-block pl-2"><s>${document.text}</s></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;

            addedAttachmentsContent += documentContent;
        }

        for (let i = 0; i < this.currentDocuments.length; i++) {
            let document = this.currentDocuments[i];
            let documentContent = `
                <div class="card">
                    <div class="card-header" id="added-attachment-${i}">
                        <div class="row justify-content-between">
                            <div class="col">
                                <div class="header-text">
                                    <a class="text-decoration-none d-flex align-items-center">
                                        <span class="expand-text d-block pl-2">${document.text}</span>
                                    </a>
                                </div>
                            </div>
                            <div class="col-auto pr-4">
                                <a data-toggle="collapse" data-target="#confirm-delete-attachment-${i}" aria-expanded="false" class="text-decoration-none add-attachment-expand">
                                    <div class="added-attachment-delete-icon">
                                        <i class="fa-solid fa-trash"></i>
                                    </div>
                                    <div class="added-attachment-cancel-icon">
                                        <i class="fa-solid fa-xmark fa-lg"></i>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div id="confirm-delete-attachment-${i}" class="collapse">
                        <div class="px-3 pb-2 d-flex align-items-center">
                            <div>
                                <button class="redbtn btn btn-sm delete-attachment-btn" type="button" data-id="${i}">Delete ${this.propertyName}</button>
                            </div>
                            <div class="px-3">
                                <button class="greybtn btn btn-sm" type="button" data-toggle="collapse" data-target="#confirm-delete-attachment-${i}">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            `;

            addedAttachmentsContent += documentContent;
        }

        return addedAttachmentsContent;
    }

    updateAddedAttachments(): void {
        // Update Added Attachments
        let addedAttachmentsCount = $(`#${this.id}-added-attachments-count`);
        addedAttachmentsCount.text(this.currentDocuments.length);

        let addedAttachmentsTable = $(`#${this.id}-added-attachments-table`);
        let updatedAttachmentsTable = this.createDocumentTable();
        addedAttachmentsTable.empty().html(updatedAttachmentsTable);
        this.initializeCurrentDocTable();
    }

    public drawGallery() {
        let uploadGallery = $(`#${this.id}-container`).find(".file-upload-gallery");
        // Empty the gallery
        uploadGallery.empty();

        // Create Table in the Gallery for each file
        let galleryContent = "";

        // Add Content for Each File
        for (let i = 0; i < this.filesToUpload.length; i++) {
            let icon = this.getFileIcon(this.filesToUpload[i].type);

            galleryContent +=
                `<div class="card">
                    <div class="card-header" id="file-heading-${i}">
                        <div class="row justify-content-between">
                            <div class="col-auto">
                                <div class="header-text">
                                    <a class="text-decoration-none d-flex align-items-center">
                                        ${icon}<span class="expand-text d-block pl-2">${this.filesToUpload[i].name}</span>
                                    </a>
                                </div>
                            </div>
                            <div class="col-auto">
                                <a id="delete-file-btn-${i}" class="text-decoration-none header-delete-btn">
                                    <i class="fa-solid fa-trash"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>`
        }

        // Draw Table
        uploadGallery.append(galleryContent);


        // Add button functionality for deleting elements
        let fileUploadObj = this;

        uploadGallery.find(".header-delete-btn").on("click", function () {
            let fileId: string = $(this).prop("id");
            let index: number = parseInt(fileId.replace("delete-file-btn-", ""));
            fileUploadObj.filesToUpload.splice(index, 1);
            fileUploadObj.drawGallery();
        });
    }

    getValue(): any {
        return null;
    }

    async uploadAttachments(entityArr: any[]): Promise<any> {
        if (this.isEdit) {
            return;
        }
        else {
            for (let i = 0; i < entityArr.length; i++) {
                let entity = entityArr[i];
                let currentId = _.get(entity, this.propertyIdName);

                let formData: FormData = new FormData();
                for (let j = 0; j < this.filesToUpload.length; j++) {
                    let key: string = currentId.toString() + "/" + this.propertyName + "/" + this.filesToUpload[j].name;
                    formData.append(key, this.filesToUpload[j]);
                }

                let result: any;
                try {
                    result = await $.ajax(this.addAttachmentsRoute, {
                        method: "POST",
                        headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val(), "RootFolderPath": this.rootFolderPath, "PropertyName": this.propertyName, "Id": currentId.toString() },
                        contentType: false,
                        cache: false,
                        processData: false,
                        data: formData
                    });
                    return result;
                }
                catch (error) {
                    alert("An error has occurred, please refresh the page and try again.");
                    console.log(error);
                }
            }     
        }
    }

    async updateAttachments(): Promise<any> {
        if (!this.isEdit) {
            return;
        }

        for (let i = 0; i < this.currentItems.length; i++) {
            let entity = this.currentItems[i];
            let currentId = _.get(entity, this.propertyIdName);

            // Upload Files
            if (this.filesToUpload.length > 0) {
                let formData: FormData = new FormData();
                for (let j = 0; j < this.filesToUpload.length; j++) {
                    let key: string = currentId.toString() + "/" + this.propertyName + "/" + this.filesToUpload[j].name;
                    formData.append(key, this.filesToUpload[j]);
                }

                let result: any;
                try {
                    result = await $.ajax(this.addAttachmentsRoute, {
                        method: "POST",
                        headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val(), "RootFolderPath": this.rootFolderPath, "PropertyName": this.propertyName, "Id": currentId.toString() },
                        contentType: false,
                        cache: false,
                        processData: false,
                        data: formData
                    });
                }
                catch (error) {
                    alert("An error has occurred, please refresh the page and try again.");
                    console.log(error);
                }
            }

            // Delete Files
            try {
                for (let k = 0; k < this.filesToDelete.length; k++) {
                    let filePath = this.filesToDelete[k].id;
                    await $.ajax(this.removeAttachmentsRoute, {
                        method: "POST",
                        headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val(), "FilePath": filePath }
                    });
                }
            }
            catch (error) {
                alert("An error has occurred, please refresh the page and try again.");
                console.log(error);
            }
        } 
    }

    validate(): boolean {
        this.resetDisplayValid();

        let isValid: boolean = true;

        if (this.isRequired) {
            if (this.isEdit) {
                if (this.filesToUpload.length == 0 && this.currentDocuments.length == 0) {
                    isValid = false;
                }
            }
            else {
                if (this.filesToUpload.length == 0) {
                    isValid = false;
                }
            }
        }

        this.displayValid(isValid);

        return isValid;
    }

    displayValid(isValid: boolean): void {
        if (isValid) {
            $(`#${this.id}-error-text`).addClass("d-none");
        }
        else {
            $(`#${this.id}-error-text`).removeClass("d-none");
        }
    }

    resetDisplayValid() {
        $(`#${this.id}-error-text`).addClass("d-none");
    }


    updateStoredValues(entityArray: any[]): void {
        return;
    }

    checkChanged(): boolean {
        if (this.filesToUpload.length > 0 || this.filesToDelete.length > 0) {
            return true;
        }
        return false;
    }

    private getFileIcon(fileType: string) {

        if (fileType.includes("image")) return `<i class="fas fa-file-image expand-btn"></i>`;
        if (fileType.includes("pdf")) return `<i class="fa-solid fa-file-pdf expand-btn"></i>`;
        if (fileType.includes("word")) return `<i class="fa-solid fa-file-word expand-btn"></i>`;
        if (fileType.includes("spreadsheet")) return `<i class="fa-solid fa-file-excel expand-btn"></i>`;
        if (fileType.includes("presentation")) return `<i class="fa-solid fa-file-powerpoint expand-btn"></i>`;
        if (fileType.includes("audio")) return `<i class="fa-solid fa-file-audio expand-btn"></i>`;
        if (fileType.includes("video")) return `<i class="fa-solid fa-file-video expand-btn"></i>`;

        return `<i class="fa-solid fa-file expand-btn"></i>`
    }
}
